import { render, staticRenderFns } from "./GarbageWCO.vue?vue&type=template&id=734e5718"
import script from "./GarbageWCO.vue?vue&type=script&lang=js"
export * from "./GarbageWCO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports